import { render, staticRenderFns } from "./PersonalIncomeReport.vue?vue&type=template&id=09885bb6"
import script from "./PersonalIncomeReport.vue?vue&type=script&lang=js"
export * from "./PersonalIncomeReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports